import React from "react"

import BaseSvgIcon from "../Base"

const MarkChatRead = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20" fill="none">
      <path
        fill="#402aff"
        d="m15.34 18-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L21 12.34zM10 15c0-3.87 3.13-7 7-7 1.08 0 2.09.25 3 .68V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v18l4-4h6c0-.17.01-.33.03-.5-.02-.16-.03-.33-.03-.5"
      />
    </BaseSvgIcon>
  )
}

export default MarkChatRead
